/** Customer-facing total incl. GST and convenience fee (falls back if grand_total missing). */
export const getBookingGrandTotal = (booking) => {
  if (!booking) return 0;
  const grand = Number(booking.grand_total);
  if (Number.isFinite(grand) && grand > 0) return grand;

  const subtotal =
    Number(booking.subtotal_after_discount) ||
    Math.max(0, Number(booking.total_amount || 0) - Number(booking.discount_amount || 0));
  const gst = Number(booking.gst_amount || 0);
  const conv = Number(booking.convenience_fee_amount || 0);
  return Math.round((subtotal + gst + conv) * 100) / 100;
};

export const getGstLabel = (booking, defaultPercent = null) => {
  const pct = booking?.gst_percent ?? defaultPercent;
  if (pct != null && pct !== "" && Number(pct) > 0) {
    return `GST (${Number(pct)}%)`;
  }
  return "GST";
};

export const getConvenienceFeeLabel = (booking) => {
  const pct = booking?.convenience_fee_percent;
  if (pct != null && pct !== "" && Number(pct) > 0) {
    return `Convenience fee (${Number(pct)}%)`;
  }
  return "Convenience fee";
};

export const BookingPricingFees = ({
  booking,
  formatCurrency,
  InfoRow,
  defaultGstPercent = null,
}) => {
  if (!booking || !InfoRow) return null;

  const gstAmount = Number(booking.gst_amount ?? 0);
  const convAmount = Number(booking.convenience_fee_amount ?? 0);

  return (
    <>
      <InfoRow
        label={getGstLabel(booking, defaultGstPercent)}
        value={formatCurrency(gstAmount)}
      />
      <InfoRow
        label={getConvenienceFeeLabel(booking)}
        value={formatCurrency(convAmount)}
      />
    </>
  );
};

export const getPricingFeeFields = (booking, formatCurrency, defaultGstPercent = null) => {
  if (!booking) return [];

  const gstAmount = Number(booking.gst_amount ?? 0);
  const convAmount = Number(booking.convenience_fee_amount ?? 0);

  return [
    {
      label: getGstLabel(booking, defaultGstPercent),
      value: formatCurrency(gstAmount),
    },
    {
      label: getConvenienceFeeLabel(booking),
      value: formatCurrency(convAmount),
    },
  ];
};

export const BookingPricingFeesGrid = ({
  booking,
  formatCurrency,
  defaultGstPercent = null,
}) => {
  if (!booking) return null;

  const gstAmount = Number(booking.gst_amount ?? 0);
  const convAmount = Number(booking.convenience_fee_amount ?? 0);

  return (
    <>
      <div>
        <p className="text-sm font-medium text-gray-500">
          {getGstLabel(booking, defaultGstPercent)}
        </p>
        <p className="mt-1">{formatCurrency(gstAmount)}</p>
      </div>
      <div>
        <p className="text-sm font-medium text-gray-500">
          {getConvenienceFeeLabel(booking)}
        </p>
        <p className="mt-1">{formatCurrency(convAmount)}</p>
      </div>
    </>
  );
};
